export default "__VITE_PUBLIC_ASSET__7ca359c7__"